import React, { useState, useEffect } from "react";
import "./Sidebar.css";
import {
  DashboardImage,
  Logo2,
  OrderIcon,
  PaymentIcon,
  People,
  ProfileIcon,
  RequestIcon,
  StockIcon,
} from "../../images/Images";

interface NavItem {
  name: string;
  icon: string;
  href: string;
}

interface SidebarProps {
  activeTab: string; // Pass active tab as a prop
}

const navItems: NavItem[] = [
  { name: "Dashboard", icon: DashboardImage, href: "/dashboard" },
  { name: "Orders", icon: OrderIcon, href: "/orders" },
  { name: "Stock", icon: StockIcon, href: "/stocks" },
  { name: "Customers", icon: People, href: "/customers" },
  { name: "Payments", icon: PaymentIcon, href: "/payments" },
  { name: "Claims", icon: RequestIcon, href: "/claims" },
  { name: "Profile", icon: ProfileIcon, href: "/profile" },
];

const Sidebar: React.FC<SidebarProps & { forceOpen?: boolean }> = ({
  activeTab,
  forceOpen,
}) => {
  const [isOpen, setIsOpen] = useState(forceOpen || false);

  useEffect(() => {
    if (forceOpen) setIsOpen(true);
  }, [forceOpen]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button className="menu-btn" onClick={toggleSidebar}>
        {isOpen ? "✖" : "☰"}
      </button>
      <div className={`side-panel ${isOpen ? "open" : ""}`}>
        <div className="side-panel-logo">
          <a href="/">
            <img src={Logo2} alt="logo" />
          </a>
        </div>
        <nav className="side-panel-nav">
          <ul>
            {navItems.map((item, index) => (
              <li
                key={index}
                className={`side-panel-item${
                  item.name === "Stock" ? " side-panel-item-stock" : ""
                }${item.name === "Orders" ? " side-panel-item-orders" : ""}${
                  item.name === "Payments" ? " side-panel-item-payments" : ""
                }${
                  item.name === "Customers" ? " side-panel-item-customers" : ""
                }${
                  item.name === "Dashboard" ? " side-panel-item-dashboard" : ""
                }${activeTab === item.name ? " active" : ""}`}
                onClick={() => (window.location.href = item.href)}
                style={{ cursor: "pointer" }}
              >
                <div className="side-panel-icon">
                  <img src={item.icon} alt={item.name} />
                </div>
                <span className="side-panel-link">{item.name}</span>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
